import {configureStore} from '@reduxjs/toolkit';
import userLeftSidebarSlice from "@/redux/slices/userLeftSidebarSlice";
import {useDispatch} from "react-redux";

export const store = configureStore({
    reducer: {
        userLeftSidebarState: userLeftSidebarSlice
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;